<template>
  <v-form ref="form" v-bind="this.$attrs">
    <div class="filter-wrapper">
      <div class="filter-options">
        <v-row>
          <v-col cols="12" md="4">
            <AutocompleteMonth label="Tháng" v-model="month" dense outlined />
          </v-col>
          <v-col cols="12" class="custom-meal-select" md="4">
            <v-select
              v-model="selectedMealSlot"
              :items="mealSlots"
              clear-icon="mdi-close"
              item-text="title"
              item-value="id"
              label="Bữa ăn"
              outlined
              dense
              clearable
              hide-details
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <GradeClassStudentSelect @changed="gradeClassStudentChange" />
          </v-col>
        </v-row>
      </div>
      <div class="filter-submit">
        <v-btn class="search-button" dark @click="onFilterChanged" outlined>
          Tìm kiếm
        </v-btn>
      </div>
    </div>
  </v-form>
</template>

<script>
import { get } from 'lodash'
import { mapActions } from 'vuex'
import AutocompleteMonth from '@/components/basic/input/AutocompleteMonth.vue'
import GradeClassStudentSelect from '@/components/basic/filter/GradeClassStudentSelect.vue'
import { MealSlot } from '@/plugins/api'
import { DEFAULT_SLOT_TITLE } from '@/modules/mealConfig/mealConfigConstants'

export default {
  components: {
    AutocompleteMonth,
    GradeClassStudentSelect
  },
  data: () => ({
    selectedGrade: {},
    selectedClass: {},
    selectedStudent: {},
    selectedMealSlot: null,
    mealSlots: [],
    month: null
  }),
  async created() {
    this.mealSlots = await MealSlot.fetch({ isActive: true, _limit: -1 })
    // mặc định bữa trưa bán trú (hoặc bữa đầu tiên)
    const lunch = this.mealSlots.find(s => s.title === DEFAULT_SLOT_TITLE)
    this.selectedMealSlot = get(lunch, 'id') || get(this.mealSlots, '0.id') || null
  },
  methods: {
    ...mapActions('MealReport', ['setSelectedSlot']),
    gradeClassStudentChange(data) {
      this.selectedGrade = { ...data.grade }
      this.selectedClass = { ...data.class }
      this.selectedStudent = { ...data.student }
    },
    onFilterChanged() {
      if (!this.$refs.form.validate() || !this.month.date) return

      const slot = this.mealSlots.find(s => String(s.id) === String(this.selectedMealSlot))
      this.setSelectedSlot(slot || null)
      const params = {
        date: this.month.date,
        mealSlot: this.selectedMealSlot,
        timeOfDay: get(slot, 'timeOfDay'),
        grade: get(this.selectedGrade, 'id'),
        class: get(this.selectedClass, 'id'),
        student: get(this.selectedStudent, 'id')
      }
      this.$emit('onFilterChanged', params)
    }
  }
}
</script>

<style lang="scss" scoped>
.filter-wrapper {
  display: flex;
  gap: 24px;

  @media screen and (max-width: 960px) {
    flex-direction: column;
  }
  .filter-options {
    flex: 1;
  }
  .filter-submit {
    margin-left: auto;
    align-self: flex-end;
  }
  @media screen and (max-width: 960px) {
    .custom-meal-select {
      margin-top: -24px !important;
      margin-bottom: 12px !important;
    }
  }
}
</style>
